import { InjectionToken } from '@angular/core';

export const CRM_API_URL = new InjectionToken<string>('CRM_API_URL');

/** Normaliza el origen público y asegura el prefijo `/api/crm`. */
export function resolveCrmApiUrl(configuredUrl: string): string {
  const normalized = configuredUrl.replace(/\/+$/, '');
  return normalized.endsWith('/api/crm')
    ? normalized
    : `${normalized}/api/crm`;
}
